// Get user initials. Accepts any object with optional name/username fields
// (covers the various user shapes the app threads through). One name part yields
// a single initial; two or more parts yield the first + last initials. When
// there is no usable name/username the `fallback` is returned (defaults to 'U';
// e.g. system rows can pass 'S').
export function getInitials(
  user?: { name?: string | null; username?: string | null } | null,
  fallback = 'U'
): string {
  const source = user?.name || user?.username
  if (!source) return fallback

  const parts = source.split(/\s+/).filter(Boolean)
  if (parts.length === 0) return fallback

  if (parts.length === 1) {
    return (parts[0][0] ?? fallback).toUpperCase()
  }

  const first = parts[0][0] ?? ''
  const last = parts[parts.length - 1][0] ?? ''
  return `${first}${last}`.toUpperCase()
}
